export const containsInvalidSymbol = (text: string): boolean => {
  if (!text) return false
  const EMOJI_REGEX = /\p{Extended_Pictographic}/u
  const INVALID_TEXT_CHARACTERS = /[\u0000-\u0008\u000B\u000C\u000E-\u001F\u007F\uFFFD\u200B\u200C\u200D\u2060\uFEFF]/

  return INVALID_TEXT_CHARACTERS.test(text) || EMOJI_REGEX.test(text)
}

export const cleanString = (text: string, multiline?: boolean) => {
  if (!text) return ''
  const cleaned = text
    .normalize('NFC')
    .replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7F]/g, ' ')
    .replace(/\u00A0/g, ' ')
    .replace(/[“”]/g, '"')
    .replace(/[‘’]/g, "'")
    .trim()

  if (!multiline) {
    cleaned
      .replace(/\r\n/g, '\n')
      .replace(/\r/g, '\n')
      .replace(/[ \t]+/g, ' ')
      .split('\n')
      .map((line) => line.trim())
      .filter(Boolean)
      .join('\n')
  }

  return cleaned
}

export const cleanText = (text: string) => {
  return cleanString(text)
    .replace(/\p{Extended_Pictographic}/gu, '')
    .replace(/[\u0000-\u0008\u000B\u000C\u000E-\u001F\u007F\uFFFD\u200B\u200C\u200D\u2060\uFEFF]/g, '')
    .trim()
}
